import { createMap } from "../omnia"

export function setupFromChanges<T>(current: T[], updated: T[], keys: number[], keySelector: (a: T) => number) {

    // Updates and deletions

    const modified = createMap(updated ?? [], keySelector)
    const available = new Set(keys ?? [])

    const result = current
        .map(b => {

            const id = keySelector(b)

            if (!available.has(id)) {
                return
            }

            const u = modified.get(keySelector(b))

            return u ? u : { ...b }

        })
        .filter(r => Boolean(r))

    // Insertions

    const set = new Set(result.map(keySelector))

    for (const n of modified.values()) {

        const id = keySelector(n)

        if (!set.has(id)) {
            result.push(n)
        }

    }

    return result

}
